import { render, staticRenderFns } from "./ColorSeriesPicker.vue?vue&type=template&id=0892fc32&scoped=true&"
import script from "./ColorSeriesPicker.vue?vue&type=script&lang=js&"
export * from "./ColorSeriesPicker.vue?vue&type=script&lang=js&"
import style0 from "./ColorSeriesPicker.vue?vue&type=style&index=0&id=0892fc32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0892fc32",
  null
  
)

export default component.exports